
import axios from "axios";
import Swal from "sweetalert2";
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.token;
axios.defaults.headers.post['Content-Type'] = 'application/json';
export default {

    errorGETHandler({ dispatch, commit }, data) {
        if (data && data.status === 403) {
            router.push('/403');
        }
        else if (data && data.status === 401) {
            dispatch('logout', null, { root: true })
        }
        else {
            console.log(data)
        }
    },

    successPOSTHandler({ dispatch, commit }, data) {
        if (data.data && data.data.status === 200) {
            commit('setSuccess', data.data.message, { root: true })
        }
        else {
            commit('setError', data.data.message, { root: true })
        }
    },

    errorPOSTHandler({ dispatch, commit }, data) {
        if (data && data.status === 403) {
            var msgData = 'شما دسترسی برای انجام این عملیات را ندارید';
            commit('setError', msgData, { root: true })
        }
        else if (data && data.status === 401) {
            dispatch('logout', null, { root: true })
        }
        else {
            commit('setError', data.data.message, { root: true })
        }
    },


    async getCurrentUser({ commit }) {
        try {
            axios
                .get(
                    "/api/Account/CurrentUser"
                )
                .then((response) => {
                    commit("SET_CurrentUser", response.data.data);
                    if(response.data.data.username==null){
                        localStorage.setItem('username', null)
                        localStorage.setItem('token', null)
                    }
                })
                .catch();
        } catch (error) {
        }
    },
    async sendCode({ commit }, data) {
        try {
            axios
                .post(
                    "/api/Account/SendCode",
                    data,
                )
                .then((resp) => {
                    console.log(resp);
                })
                .catch((err) => console.error(err));
            //commit("SET_USERS", data.data);
        } catch (error) {
            alert(error);
            console.log(error);
        }
    },
    async loginWithCode({ commit }, data) {
        try {
            const request = await axios.post(
                "/api/Account/loginWithCode", data
            ).then(result => {
                commit("SET_REGISTER_RESULT", result.data);
                if (result.data.status === 200) {
                    localStorage.setItem('token', result.data.data.accessToken)
                    localStorage.setItem('username', result.data.data.username)
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.token;
                    window.location.reload()
                }
                else {

                }
            }
            ).catch(error => { console.log(error.message) }
            ).finally(
                {}
            );
            //commit("SET_USERS", data.data);
        } catch (error) {
            alert(error);
            console.log(error);
        }
    },
    async saveUserInfo({ commit }, data) {
        try {
            axios
                .post(
                    "/api/Account/saveUserInfo",
                    data,
                )
                .then((response) => {
                    if (response.data.status === 200) {
                        var message = response.data.message;
                        Swal.fire({
                            title: "پیغام",
                            text: message,
                            timer: 5000,
                            icon: 'success',
                            confirmButtonText: "ok",
                        });
                    }
                    else {
                        var message = response.data.message;
                        Swal.fire({
                            title: "پیغام",
                            text: message,
                            timer: 5000,
                            icon: 'error'
                        });
                    }
                })
                .catch((err) => console.error(err));
            //commit("SET_USERS", data.data);
        } catch (error) {
            alert(error);
            console.log(error);
        }
    },
    async changeMobile({ dispatch, commit }, data) {
        try {
            axios
                .post(
                    "/api/Account/changeMobile",
                    data,
                )
                .then((response) => {
                    if (response.data.status === 200) {
                        var message = response.data.message;
                        Swal.fire({
                            title: "پیغام",
                            text: message,
                            timer: 5000,
                            icon: 'success',
                            confirmButtonText: "ok",
                        });
                        dispatch("loginWithCode", { mobileNumber: data.mobileNumber, code: data.code, });
                    }
                    else {

                        var message = response.data.message;
                        Swal.fire({
                            title: "پیغام",
                            text: message,
                            timer: 5000,
                            icon: 'error'
                        });
                    }
                })
                .catch((err) => console.error(err));
            //commit("SET_USERS", data.data);
        } catch (error) {
            alert(error);
            console.log(error);
        }
    },
    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        axios.defaults.headers.common['Authorization'] = '';
        window.location.href = '/';
    },
}